<template>
  <div class="title" :style="`width: ${width}px;height: ${height}px;`">
    <div class="t-left">
      <div class="l-top" :style="`width: ${width}px}`">
        <p class="text" :style="`margin-left:${margin}px`">{{ gettitle(title) }}</p>
        <p class="text2" v-if="extend">/</p>
        <p class="text2" v-if="extend">{{ extend }}</p>
        <div class="more-btn" @click="tomore" v-if="isMore">查看更多></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'scopetitle.textTitle2',
  props: {
    title: {
      type: [String, Object],
      default: ""
    },
    width: {
      type: String,
      default: "435"
    },
    height: {
      type: String,
      default: "40"
    },
    margin: {
      type: String,
      default: "0"
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extend: ''
    };
  },
  watch: {},
  methods: {
    ...methods
  },
  mounted() { },
};
</script>

<style scoped lang="scss">
.title {
  width: 435px;
  height: 40px;
}

.t-left {
  .l-top {
    width: 435px;
    height: 37.5px;
    background: url('@/assets/scopetitle/title2.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 5px 0 0 80px;
    display: flex;
    align-items: center;

    .text {
      font-weight: 400;
      font-size: 17px;
      color: #FFFFFF;
    }

    .text2 {
      margin-left: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #8798AC;
      line-height: 12px;
    }

    .more-btn {
      margin: 0 24px 0 auto;
      font-size: 14px;
      color: #51a0f4;
      cursor: pointer;
      pointer-events: auto;
    }
  }
}
</style>